import { apiRequest } from "./api";

export interface Notification {
  id: string;
  user_id: string;
  channel: string;
  template_code: string;
  title: string | null;
  payload: {
    message?: string;
    action_url?: string;
    [key: string]: any;
  };
  status: string;
  read_at: string | null;
  created_at: string;
}

export async function getNotifications(params?: {
  unread_only?: boolean;
  limit?: number;
  offset?: number;
}): Promise<{ notifications: Notification[]; unreadCount: number }> {
  const query = new URLSearchParams();
  if (params?.unread_only) query.append("unread_only", "true");
  if (params?.limit) query.append("limit", params.limit.toString());
  if (params?.offset) query.append("offset", params.offset.toString());

  const url = query.toString() ? `/notifications?${query}` : "/notifications";
  return apiRequest(url, { method: "GET" });
}

export async function markAsRead(id: string): Promise<Notification> {
  return apiRequest(`/notifications/${id}/read`, { method: "PATCH" });
}

export async function markAllAsRead(): Promise<{ message: string }> {
  return apiRequest("/notifications/mark-all-read", { method: "PATCH" });
}

export async function deleteNotification(id: string): Promise<{ message: string }> {
  return apiRequest(`/notifications/${id}`, { method: "DELETE" });
}

export async function registerDevice(token: string, platform: "web" | "ios" | "android") {
  return apiRequest("/notifications/devices", {
    method: "POST",
    data: { token, platform },
  });
}
